require.register("picture/controllers/bulkCtrl", function(exports, require, module){
  $0
  
});

